export const genderOpts = [
	{
		name: "Laki-laki",
		value: "laki-laki",
	},
	{
		name: "Perempuan",
		value: "perempuan",
	},
	{
		name: "Aku nggak mau kasih tau",
		value: "non-biner",
	},
];

export const dirtyCondition = [
	{
		name: "Very Dry",
		value: "Very Dry",
	},
	{
		name: "Often Dry",
		value: "Often Dry",
	},
	{
		name: "Combination",
		value: "Combination",
	},
	{
		name: "Often Oily",
		value: "Often Oily",
	},
	{
		name: "Very Oily",
		value: "Very Oily",
	},
];

export const sensitiveCondition = [
	{
		name: "Kulitku sangat mudah iritasi",
		value: "Kulitku sangat mudah iritasi",
	},
	{
		name: "Kulitku jarang iritasi",
		value: "Kulitku jarang iritasi",
	},
	{
		name: "Aku ngga tau nih! Aku jarang pakai produk baru",
		value: "Aku ngga tau nih! Aku jarang pakai produk baru",
	},
];

export const acne = [
	{
		name: "TIdak ada jerawat nih",
		value: "TIdak ada jerawat nih",
	},
	{
		name: "Blackheads / whiteheads",
		value: "Blackheads / whiteheads",
	},
	{
		name: "Papule",
		value: "Papule",
	},
	{
		name: "Pustule",
		value: "Pustule",
	},
	{
		name: "Noudles",
		value: "Noudles",
	},
	{
		name: "Aku masih bingung nih",
		value: "Aku masih bingung nih",
	},
];

export const listData = [
	{
		name: "Introduksi",
		value: 1,
	},
	{
		name: "Data Diri",
		value: 2,
	},
	{
		name: "Kondisi Kulit Kamu",
		value: 3,
	},
	{
		name: "Keparahan Jerawat",
		value: 4,
	},
	{
		name: "Pengalaman Kamu",
		value: 5,
	},
	{
		name: "Cerita Lengkap Jerawat",
		value: 6,
	},
	{
		name: "Hasil Assement",
		value: 7,
	},
];

export const breastFeeding = [
	{
		name: "Yes, aku sedang menyusui",
		value: "Yes, aku sedang menyusui",
	},
	{
		name: "Tidak, aku tidak menyusui",
		value: "Tidak, aku tidak menyusui",
	},
];

export const yesOrNO = [
	{
		name: "Pernah",
		value: "Pernah",
	},
	{
		name: "Belum pernah",
		value: "Belum pernah",
	},
	{
		name: "Tidak tau",
		value: "Tidak tau",
	},
];

export const skincareTypeName = [
	{
		name: "Cleanser",
		value: "Cleanser",
	},
	{
		name: "Moisturizer",
		value: "Moisturizer",
	},
	{
		name: "Toner",
		value: "Toner",
	},
	{
		name: "Chemical exfoliator",
		value: "Chemical exfoliator",
	},
	{
		name: "Serum",
		value: "Serum",
	},
	{
		name: "Eye Cream",
		value: "Eye Cream",
	},
	{
		name: "Mask",
		value: "Mask",
	},
	{
		name: "Lip balm",
		value: "Lip balm",
	},
	{
		name: "Makeup",
		value: "Makeup",
	},
	{
		name: "None of the above",
		value: "None of the above",
	},
];

export const serumIngredient = [
	{
		name: "Retinol",
		value: "Retinol",
	},
	{
		name: "Hydroquinone",
		value: "Hydroquinone",
	},
	{
		name: "Tropical steroid",
		value: "Tropical steroid",
	},
];

export const goodRetino = [
	{
		name: "Kulitku berespon baik",
		value: "Kulitku berespon baik",
	},
	{
		name: "Kulitku iritasi :(",
		value: "Kulitku iritasi :(",
	},
];

export const yesOrNOChoosen = [
	{
		name: "Ya",
		value: "Ya",
	},
	{
		name: "Tidak",
		value: "Tidak",
	},
	{
		name: "Mungkin",
		value: "Mungkin",
	},
];

export const rangeChoosen = [
	{
		value: 1,
	},
	{
		value: 2,
	},
	{
		value: 3,
	},
	{
		value: 4,
	},
	{
		value: 5,
	},
	{
		value: 6,
	},
	{
		value: 7,
	},
	{
		value: 8,
	},
	{
		value: 9,
	},
	{
		value: 10,
	},
];

export const dataHome = [
	{
		title: "Set Account",
		desc: "Lorem ipsum dolor sit amet, consectetur.",
		value: "01",
	},
	{
		title: "Mengisi Asessment",
		desc: "Lorem ipsum dolor sit amet, consectetur.",
		value: "02",
	},

	{
		title: "Mendapatkan Rekomendasi",
		desc: "Lorem ipsum dolor sit amet, consectetur.",
		value: "03",
	},
	{
		title: "Lorem Ipsum",
		desc: "Lorem ipsum dolor sit amet, consectetur.",
		value: "04",
	},
	{
		title: "Lorem Ipsum",
		desc: "Lorem ipsum dolor sit amet, consectetur.",
		value: "05",
	},
];
